import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import { useStyles } from './styles';

function ModalSignatureDetails({ plano }) {
  const { nome, descricao, valor } = plano;

  const classes = useStyles();

  const valueString = parseFloat(valor) / 100;

  return (
    <div style={{ paddingHorizontal: 15, paddingTop: 15 }}>
      <Typography className={classes.itemHeader}>
        Plano de Assinatura
      </Typography>
      <Typography className={classes.textHeader}>{nome}</Typography>
      <Typography className={classes.itemHeader}>
        Beneficios do Plano
      </Typography>
      <Typography className={classes.textHeader}>{descricao}</Typography>
      <Typography className={classes.itemHeader}>Valor do Plano</Typography>
      <Typography className={classes.textHeader}>
        {`R$ ${valueString} /mês`}
      </Typography>
    </div>
  );
}

ModalSignatureDetails.propTypes = {
  plano: PropTypes.shape({
    nome: PropTypes.string,
    descricao: PropTypes.string,
    valor: PropTypes.number,
  }),
};

export default ModalSignatureDetails;
